// ---------- Status → colour ----------
export function statusColor(statusArr) {
  const hasFP = Array.isArray(statusArr) && statusArr.includes("FP");
  const hasMA = Array.isArray(statusArr) && statusArr.includes("MA");
  const hasNAP = Array.isArray(statusArr) && statusArr.includes("NAP");
  if (hasFP && hasMA) return "#3f1c7bff"; // purple
  if (hasFP) return "#9e145bff"; // blue
  if (hasMA) return "#ed7600ff"; // green
  if (hasNAP) return "#096039ff"; // yellow
  return "#FFEE74"; // grey
}
